/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CreateMediaExportJobsMutationRequest, CreateMediaExportJobsMutationResponse } from "../models/CreateMediaExportJobs";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createMediaExportJobs } from "../axios/createMediaExportJobs";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createMediaExportJobsMutationKey = () => ["web-app-bff-api", { url: '/export-jobs' }] as const

export type CreateMediaExportJobsMutationKey = ReturnType<typeof createMediaExportJobsMutationKey>

export function createMediaExportJobsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateMediaExportJobsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createMediaExportJobsMutationKey()
        return mutationOptions<CreateMediaExportJobsMutationResponse, ResponseErrorConfig<Error>, {data: CreateMediaExportJobsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return createMediaExportJobs(data, config)
          },
        })

}

/**
 * @description Adds an export media job for the current user. Returns the job (id, status, progress, etc.).
 * @summary Enqueue export job
 * {@link /export-jobs}
 */
export function useCreateMediaExportJobs<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateMediaExportJobsMutationResponse, ResponseErrorConfig<Error>, {data: CreateMediaExportJobsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateMediaExportJobsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createMediaExportJobsMutationKey()

          const baseOptions = createMediaExportJobsMutationOptions(config) as UseMutationOptions<CreateMediaExportJobsMutationResponse, ResponseErrorConfig<Error>, {data: CreateMediaExportJobsMutationRequest}, TContext>
          

          return useMutation<CreateMediaExportJobsMutationResponse, ResponseErrorConfig<Error>, {data: CreateMediaExportJobsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateMediaExportJobsMutationResponse, ResponseErrorConfig<Error>, {data: CreateMediaExportJobsMutationRequest}, TContext>
      
}